import { NavLink, useNavigate } from 'react-router-dom';
import { ListChecks, SignOut } from '@phosphor-icons/react';
import { useAuth } from '@/contexts/AuthContext';

const NAV = [
  { to: '/colaborador/tarefas', label: 'Tarefas', icon: ListChecks },
];

export default function ColaboradorLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-brand-bg flex" data-testid="colaborador-layout">
      <aside className="w-60 shrink-0 bg-white border-r border-brand-border flex flex-col fixed inset-y-0 left-0">
        <div className="px-5 py-5 border-b border-brand-border">
          <p className="font-heading font-semibold text-brand-text text-lg">nutrianapereira</p>
          <p className="text-[11px] text-brand-muted mt-0.5">Área da Equipa</p>
        </div>
        <nav className="flex-1 py-3" data-testid="colaborador-nav">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink key={to} to={to} data-testid={`colaborador-nav-${to.split('/').pop()}`}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors ${isActive ? 'bg-brand-green/10 text-brand-green font-medium border-r-2 border-brand-green' : 'text-brand-muted hover:bg-brand-bg hover:text-brand-text'}`}>
              <Icon size={18} weight="duotone" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-4 border-t border-brand-border">
          <p className="text-[11px] text-brand-muted mb-2 truncate">{user?.name}</p>
          <button onClick={() => { logout(); navigate('/login'); }} className="flex items-center gap-2 text-sm text-red-500 hover:text-red-600" data-testid="colaborador-logout-btn">
            <SignOut size={16} /> Terminar sessão
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 p-6 max-w-4xl">{children}</main>
    </div>
  );
}
